import React, {useEffect, useState} from "react";
import {DatasetsApi} from "api/DatasetsApi";
import {AutoComplete, AutoCompleteChangeParams, AutoCompleteCompleteMethodParams} from "primereact/autocomplete";

interface IDatasetDropdownProps {
    // Dataset identifier
    value?: string | null;
    onChange: (e: string | null) => void;
    style?: React.CSSProperties;
}

interface DropdownItem {
    value: string | number,
    label: string,
}

export function DatasetDropdown(props: IDatasetDropdownProps) {
    const [selectedDataset, setSelectedDataset] = useState<DropdownItem | null>(null);
    const [filteredDatasets, setFilteredDatasets] = useState<DropdownItem[]>([]);

    const [error, setError] = useState(false);

    useEffect(() => {
        DatasetsApi.getDatasetInfo(props.value!).then((r) => {
            if (!r.error && r.data) {
                setSelectedDataset({value: r.data.identifier!!, label: r.data.toString()})
            }
        });
    }, [])

    const searchDatasets = (e: AutoCompleteCompleteMethodParams) => {
        DatasetsApi.queryDatasets(e.query, 100).then((r) => {
            if (!r.error && r.data) {
                const selections = r.data.map((it) => ({value: it.identifier, label: it.toString()} as DropdownItem))
                setFilteredDatasets(selections)
            } else {
                setError(true)
            }
        });
    }

    const onChange = (e: AutoCompleteChangeParams) => {
        setSelectedDataset(e.value);

        if (typeof e.value === "string") return; // Ignore string auto complete dumb input

        props.onChange(e.value?.value || null);
    }

    return <>
        <AutoComplete placeholder="Select Dataset"
                      value={selectedDataset}
                      suggestions={filteredDatasets}
                      onChange={onChange}
                      completeMethod={searchDatasets}
                      minLength={3}
                      field="label"
                      onClear={() => {
                          setSelectedDataset(null);
                          props.onChange(null);
                      }}
                      dropdownMode="blank"
                      style={{width: "100%", ...props.style}}
                      dropdown
        />
    </>
}